import { ApiService } from "./ApiService"

export class PppoeUserImageService {

    static uri = '/pppoe-user-image';

    static create({ data, pppoeUserId }) {
        return ApiService.post(`${this.uri}/create/${pppoeUserId}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static delete({ id }) {
        return ApiService.post(`${this.uri}/delete/${id}`, {},{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}